"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let PaymentsFilters = class PaymentsFilters extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "PaymentsFilters");
    }
    createAccountGrups(...args) {
        const [accounts] = args;
        const showInactiveAccounts = this.item.showInactiveAccounts;
        return _
            .chain(accounts)
            .groupBy(p => p.owner.id)
            .map((items, owner_id) => ({
            id: owner_id,
            name: items[0].owner.name,
            items: !showInactiveAccounts ? _.filter(items, { inactive: false }) : items
        }))
            .filter(p => p.items.length)
            .value();
    }
    mounted(...args) {
        this.actions.load.trigger(this);
    }
    item;
    accounts;
    async $$load_accounts() {
        return this.$fn.fetch('list_account')
            .then(resp => _.orderBy(resp.data, ['inactive', 'account_type', 'name'], ['asc', 'desc', 'asc']));
    }
    accountGroups;
    async $$load_accountGroups() {
        return this.createAccountGrups(this.$data.accounts);
    }
    ux;
    b_5962862420439144_style;
    dataMembers = ['item', 'accounts', 'accountGroups', 'ux', 'b_5962862420439144_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: {
                    date_from: null,
                    date_to: null,
                    account: null,
                    showInactiveAccounts: false,
                },
                accounts: null,
                accountGroups: null,
                ux: null,
                b_5962862420439144_style: {
                    width: "500px",
                },
            },
        };
    }
    get selectedAccountType() {
        if (this.loaded) {
            return this.item.account && this.item.account.account_type;
        }
        return null;
    }
    get selectedAccount() {
        if (this.loaded) {
            return _.isObject(this.item.account) ? this.item.account : null;
        }
        return null;
    }
    async act_2248226175642056_emit_7960_getActionArgs($event) {
        return {
            event: "submit",
            value: { ...this.item, account: this.item.account?.id },
        };
    }
    async evh_2248226175642056_input_7959_getWhen($event) {
        return !!this.item.date_from;
    }
    async evh_2248226175642056_input(event, scope) {
        return await this.actions.evh_2248226175642056_input.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_setData_7962_getActionArgs($event) {
        return {
            path: "item.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5962862420439144_setData_7964_getActionArgs($event) {
        return {
            path: "item.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_5962862420439144_changed(event, scope) {
        return await this.actions.evh_5962862420439144_changed.executeFromDOM(this, event, scope);
    }
    async act_8358196963355853_emit_7966_getActionArgs($event) {
        return {
            event: "submit",
            value: { ...this.item, account: this.item.account?.id },
        };
    }
    async evh_8358196963355853_click(event, scope) {
        return await this.actions.evh_8358196963355853_click.executeFromDOM(this, event, scope);
    }
    async act_6424600534600827_showModal_7968_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                accountId: this.item.account ? this.item.account.id : null,
                transactionKind: "cash_book",
                transactionType: "deposit",
            },
        };
    }
    async evh_6424600534600827_clickPrevent(event, scope) {
        return await this.actions.evh_6424600534600827_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_8249915319319009_showModal_7970_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                accountId: this.item.account ? this.item.account.id : null,
                transactionKind: "cash_book",
                transactionType: "payment",
            },
        };
    }
    async evh_8249915319319009_clickPrevent(event, scope) {
        return await this.actions.evh_8249915319319009_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_2276125547171722_showModal_7972_getActionArgs($event) {
        return {
            name: "Payment",
            props: {
                accountId: this.item.account ? this.item.account.id : null,
                transactionKind: this.selectedAccountType === 'bank_account' ? 'bank' : this.selectedAccountType,
            },
        };
    }
    async evh_2276125547171722_clickPrevent(event, scope) {
        return await this.actions.evh_2276125547171722_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_1836715606397834_showModal_7974_getActionArgs($event) {
        return {
            name: "ImportBankStatement",
        };
    }
    async evh_1836715606397834_clickPrevent(event, scope) {
        return await this.actions.evh_1836715606397834_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_2248226175642056_emit_7960 = new core_1.actions.EmitAction({
            actionArgs: this.act_2248226175642056_emit_7960_getActionArgs,
            displayName: "load",
            events: [],
        });
        const evh_2248226175642056_input_7959 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_emit_7960,
            event: "input",
            when: this.evh_2248226175642056_input_7959_getWhen,
            displayName: "load",
        });
        const evh_2248226175642056_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_input_7959],
        });
        const act_5962862420439144_setData_7962 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_7962_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_changed_7961 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_7962,
            event: "changed",
            displayName: "setData",
        });
        const act_5962862420439144_setData_7964 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5962862420439144_setData_7964_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_changed_7963 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_setData_7964,
            event: "changed",
            displayName: "setData",
        });
        const evh_5962862420439144_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_changed_7961, evh_5962862420439144_changed_7963],
        });
        const act_8358196963355853_emit_7966 = new core_1.actions.EmitAction({
            actionArgs: this.act_8358196963355853_emit_7966_getActionArgs,
            displayName: "load",
            events: [],
        });
        const evh_8358196963355853_click_7965 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_emit_7966,
            event: "click",
            displayName: "load",
        });
        const evh_8358196963355853_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8358196963355853_click_7965],
        });
        const act_6424600534600827_showModal_7968 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6424600534600827_showModal_7968_getActionArgs,
            events: [],
        });
        const evh_6424600534600827_clickPrevent_7967 = new core_1.actions.EventHandlerImpl({
            action: act_6424600534600827_showModal_7968,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_6424600534600827_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6424600534600827_clickPrevent_7967],
        });
        const act_8249915319319009_showModal_7970 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8249915319319009_showModal_7970_getActionArgs,
            events: [],
        });
        const evh_8249915319319009_clickPrevent_7969 = new core_1.actions.EventHandlerImpl({
            action: act_8249915319319009_showModal_7970,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_8249915319319009_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8249915319319009_clickPrevent_7969],
        });
        const act_2276125547171722_showModal_7972 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2276125547171722_showModal_7972_getActionArgs,
            events: [],
        });
        const evh_2276125547171722_clickPrevent_7971 = new core_1.actions.EventHandlerImpl({
            action: act_2276125547171722_showModal_7972,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_2276125547171722_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2276125547171722_clickPrevent_7971],
        });
        const act_1836715606397834_showModal_7974 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1836715606397834_showModal_7974_getActionArgs,
            events: [],
        });
        const evh_1836715606397834_clickPrevent_7973 = new core_1.actions.EventHandlerImpl({
            action: act_1836715606397834_showModal_7974,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_1836715606397834_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1836715606397834_clickPrevent_7973],
        });
        return {
            act_2248226175642056_emit_7960,
            evh_2248226175642056_input_7959,
            evh_2248226175642056_input,
            act_5962862420439144_setData_7962,
            evh_5962862420439144_changed_7961,
            act_5962862420439144_setData_7964,
            evh_5962862420439144_changed_7963,
            evh_5962862420439144_changed,
            act_8358196963355853_emit_7966,
            evh_8358196963355853_click_7965,
            evh_8358196963355853_click,
            act_6424600534600827_showModal_7968,
            evh_6424600534600827_clickPrevent_7967,
            evh_6424600534600827_clickPrevent,
            act_8249915319319009_showModal_7970,
            evh_8249915319319009_clickPrevent_7969,
            evh_8249915319319009_clickPrevent,
            act_2276125547171722_showModal_7972,
            evh_2276125547171722_clickPrevent_7971,
            evh_2276125547171722_clickPrevent,
            act_1836715606397834_showModal_7974,
            evh_1836715606397834_clickPrevent_7973,
            evh_1836715606397834_clickPrevent,
            load: act_8358196963355853_emit_7966,
        };
    }
};
PaymentsFilters = __decorate([
    (0, vue_property_decorator_1.Component)()
], PaymentsFilters);
exports.default = PaymentsFilters;
vue_property_decorator_1.Vue.component("PaymentsFilters", PaymentsFilters);
